// @core/api/endpoints/billing/list_accounts.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListAccountsResponse,
} from '../../../types/billing';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/billing';

/**
 * List accounts (Chart of Accounts)
 * Returns the complete Chart of Accounts with optional filtering by account type, subtype, or active status. Supports pagination for large account structures.
 */
export async function ListAccounts(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListAccountsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/accounts`;
  const requestOptions = options;
  return client.get<ListAccountsResponse>(requestPath, { ...requestOptions, params });
}
